export default (value, applyNegSign = true, addPlusSign = false) => {
  // Handle invalid/non-numeric input
  if (value === null || value === undefined || isNaN(value)) return '$0.00'

  const amt = Number(value)

  // Handle zero amount
  if (amt === 0) return '$0.00'

  // Determine prefix based on amount and flags
  const prefix = amt < 0 && applyNegSign ? '- $' : addPlusSign ? '+ $' : '$'

  try {
    // Format number with 2 decimal places
    return (
      prefix +
      Math.abs(amt).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    )
  } catch (err) {
    return '$0.00'
  }
}
